import * as api from "./api";

const COMMON_ERROR = "Error, Please try again.!";
const errorResponse = (error) => {
    if (error.response) {
        const { status, data } = error.response;
        if (status === 403) {
            setTimeout(() => {
                window.location.href = "/";
                localStorage.clear();
            }, 5000);
        };
        return data;
    } else {
        return { status: 0, message: COMMON_ERROR };
    };
};

let setFormData = (_payload) => {
    let formData = new FormData();
    for (let key in _payload) {
        if (key === "themeTag" || key === "themeCategory" || key === "country" || key === "region" || key === "bigPreviewStickerStore") {
            _payload[key].forEach((_item) => formData.append(`${key}`, _item))
        } else {
            formData.append(`${key}`, _payload[key]);
        };
    };
    return formData;
};

// SIGNIN ACTIONS
export const admin_signin = async (_payload) => {
    try {
        // let formData = setFormData(_payload);
        const { data } = await api.adminSigninAPI(_payload);
        return data;
    } catch (error) {
        // console.error(`admin_signin ====>>>> : ${error}`, error);
        return errorResponse(error);
    };
};

// DASHBOARD ACTIONS
export const get_dashboard_data = async (_payload) => {
    try {
        const { data } = await api.getDashboardAPI(_payload);
        return data;
    } catch (error) {
        // console.error('get_dashboard_data ====>>>> ', error);
        return errorResponse(error);
    };
};

// COUNTRY AND REGION ACTIONS
export const get_country_data = async () => {
    try {
        const { data } = await api.getCountryAPI();
        return data;
    } catch (error) {
        // console.error('get_country_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const get_region_data = async () => {
    try {
        const { data } = await api.getRegionAPI();
        return data;
    } catch (error) {
        // console.error('get_region_data ====>>>> ', error);
        return errorResponse(error);
    };
};

// SLIDERS ACTIONS
export const get_sliders_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getSlidersAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getSlidersAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_sliders_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_slider = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        // for (var [key, value] of formData.entries()) {
        //     console.log(key, value, '---------56565656565656565656');
        // }
        const { data } = await api.addSlidersAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_slider ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_slider = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateSlidersAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_slider ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_slider = async (_id) => {
    try {
        const { data } = await api.deleteSlidersAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_slider ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_slider = async (_payload) => {
    try {
        const { data } = await api.deleteAllSlidersAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_slider ====>>>> ', error);
        return errorResponse(error);
    };
};

// SLIDER TAG ACTIONS
export const get_slider_tag = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getSliderTagAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getSliderTagAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_slider_tag ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_slider_tags = async (_payload) => {
    try {
        const { data } = await api.addSliderTagAPI(_payload);
        return data;
    } catch (error) {
        // console.error('add_slider_tags ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_slider_tags = async (_payload, _id) => {
    try {
        const { data } = await api.updateSliderTagAPI(_payload, _id);
        return data;
    } catch (error) {
        // console.error('update_slider_tags ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_slider_tag = async (_id) => {
    try {
        const { data } = await api.deleteSliderTagAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_slider_tag ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_slider_tag = async (_payload) => {
    try {
        const { data } = await api.deleteAllSliderTagAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_slider_tag ====>>>> ', error);
        return errorResponse(error);
    };
};

// THEMES ACTIONS
export const get_themes_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getThemesAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getThemesAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_themes_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_theme = async (_payload) => {
    try {
        // console.log(_payload);
        let formData = setFormData(_payload);
        // for (var [key, value] of formData.entries()) {
        //     console.log(key, " : ", value);
        // }
        const { data } = await api.addThemeAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_theme ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_theme = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateThemeAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_theme ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_theme = async (_id) => {
    try {
        const { data } = await api.deleteThemeAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_themes = async (_payload) => {
    try {
        const { data } = await api.deleteAllThemesAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_themes ====>>>> ', error);
        return errorResponse(error);
    };
};

// THEME CATEGORIES ACTIONS
export const get_theme_categories_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let categoryData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getThemeCategoryAPI(_currentPage, _perPage, _search, _filterDropdown);
            categoryData = data;
        } else {
            const { data } = await api.getThemeCategoryAPI();
            categoryData = data;
        }
        return categoryData;
    } catch (error) {
        // console.error('get_theme_categories_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_theme_category = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const data = await api.addThemeCategoryAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_theme_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_theme_category = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateThemeCategoryAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_theme_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_theme_category = async (_id) => {
    try {
        const { data } = await api.deleteThemeCategoryAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_theme_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_theme_category = async (_payload) => {
    try {
        const { data } = await api.deleteAllCategoryAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_theme_category ====>>>> ', error);
        return errorResponse(error);
    };
};

// THEMES TAG ACTIONS
export const get_tag = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getTagAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getTagAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_tag ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_tags = async (_payload) => {
    try {
        const { data } = await api.addTagAPI(_payload);
        return data;
    } catch (error) {
        // console.error('add_tags ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_tags = async (_payload, _id) => {
    try {
        const { data } = await api.updateTagAPI(_payload, _id);
        return data;
    } catch (error) {
        // console.error('update_tags ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_tag = async (_id) => {
    try {
        const { data } = await api.deleteUpdateTagAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_tag ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_tag = async (_payload) => {
    try {
        const { data } = await api.deleteAllTagAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_tag ====>>>> ', error);
        return errorResponse(error);
    };
};

// BACKGROUND ACTIONS
export const get_background_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getBackgroundAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getBackgroundAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_background_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_background = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addBackgroundAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_background ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_background = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateBackgroundAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_background ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_background = async (_id) => {
    try {
        const { data } = await api.deleteBackgroundAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_background ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_background = async (_payload) => {
    try {
        const { data } = await api.deleteAllBackgroundAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_background ====>>>> ', error);
        return errorResponse(error);
    };
};

// BACKGROUND CATEGORIES ACTIONS
export const get_background_categories_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let categoryData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getBackgroundCategoryAPI(_currentPage, _perPage, _search, _filterDropdown);
            categoryData = data;
        } else {
            const { data } = await api.getBackgroundCategoryAPI();
            categoryData = data;
        }
        return categoryData;
    } catch (error) {
        // console.error('get_background_categories_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_background_category = async (_payload) => {
    try {
        const data = await api.addBackgroundCategoryAPI(_payload);
        return data;
    } catch (error) {
        // console.error('add_background_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_background_category = async (_payload, _id) => {
    try {
        const { data } = await api.updateBackgroundCategoryAPI(_payload, _id);
        return data;
    } catch (error) {
        // console.error('update_background_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_background_category = async (_id) => {
    try {
        const { data } = await api.deleteBackgroundCategoryAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_background_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_background_category = async (_payload) => {
    try {
        const { data } = await api.deleteAllBackgroundCategoryAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_background_category ====>>>> ', error);
        return errorResponse(error);
    };
};

// EFFECTS ACTIONS
export const get_effects_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getEffectsAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getEffectsAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_effects_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_effects = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addEffectAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_effects ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_effects = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateEffectAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_effects ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_effects = async (_id) => {
    try {
        const { data } = await api.deleteEffectAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_effects ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_effects = async (_payload) => {
    try {
        const { data } = await api.deleteAllEffectAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_effects ====>>>> ', error);
        return errorResponse(error);
    };
};

// FONTLISTS ACTIONS
export const get_fontlist_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getFontListAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getFontListAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_fontlist_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_fontlist = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addFontListAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_fontlist ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_fontlist = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateFontListAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_fontlist ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_fontlist = async (_id) => {
    try {
        const { data } = await api.deleteFontListsAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_fontlist ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_fontlist = async (_payload) => {
    try {
        const { data } = await api.deleteAllFontlistAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_fontlist ====>>>> ', error);
        return errorResponse(error);
    };
};

// SOUNDS ACTIONS
export const get_sounds_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getSoundsAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getSoundsAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_sounds_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_sounds = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addSoundsAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_sounds ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_sounds = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateSoundsAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_sounds ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_sounds = async (_id) => {
    try {
        const { data } = await api.deleteSoundsAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_sounds ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_sounds = async (_payload) => {
    try {
        const { data } = await api.deleteAllSoundlistAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_sounds ====>>>> ', error);
        return errorResponse(error);
    };
};

// STICKERSTORE ACTIONS
export const get_sticker_store_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getStickerStoreAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getStickerStoreAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_sticker_store_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_sticker_store = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addStickerStoreAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_sticker_store ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_sticker_store = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateStickerStoreAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_sticker_store ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_sticker_store = async (_id) => {
    try {
        const { data } = await api.deleteStickerStoreAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_sticker_store ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_sticker_store = async (_payload) => {
    try {
        const { data } = await api.deleteAllStickerStoreAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_sticker_store ====>>>> ', error);
        return errorResponse(error);
    };
};

// SETTING ACTIONS
export const add_setting = async (_payload) => {
    try {
        const { data } = await api.addSettingAPI(_payload);
        return data;
    } catch (error) {
        // console.error('add_setting ====>>>> ', error);
        return errorResponse(error);
    };
};

// WALLPAPER ACTIONS
export const get_wallpaper_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let getData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getWallpaperAPI(_currentPage, _perPage, _search, _filterDropdown);
            getData = data;
        } else {
            const { data } = await api.getWallpaperAPI();
            getData = data;
        };
        return getData;
    } catch (error) {
        // console.error('get_wallpaper_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_wallpaper = async (_payload) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.addWallpaperAPI(formData);
        return data;
    } catch (error) {
        // console.error('add_wallpaper ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_wallpaper = async (_payload, _id) => {
    try {
        let formData = setFormData(_payload);
        const { data } = await api.updateWallpaperAPI(formData, _id);
        return data;
    } catch (error) {
        // console.error('update_wallpaper ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_wallpaper = async (_id) => {
    try {
        const { data } = await api.deleteWallpaperAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_wallpaper ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_wallpaper = async (_payload) => {
    try {
        const { data } = await api.deleteAllWallpaperAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_wallpaper ====>>>> ', error);
        return errorResponse(error);
    };
};

// WALLPAPER CATEGORIES ACTIONS
export const get_wallpaper_categories_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let categoryData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getWallpaperCategoryAPI(_currentPage, _perPage, _search, _filterDropdown);
            categoryData = data;
        } else {
            const { data } = await api.getWallpaperCategoryAPI();
            categoryData = data;
        }
        return categoryData;
    } catch (error) {
        // console.error('get_wallpaper_categories_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const add_wallpaper_category = async (_payload) => {
    try {
        const data = await api.addWallpaperCategoryAPI(_payload);
        return data;
    } catch (error) {
        // console.error('add_wallpaper_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const update_wallpaper_category = async (_payload, _id) => {
    try {
        const { data } = await api.updateWallpaperCategoryAPI(_payload, _id);
        return data;
    } catch (error) {
        // console.error('update_wallpaper_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_wallpaper_category = async (_id) => {
    try {
        const { data } = await api.deleteWallpaperCategoryAPI(_id);
        return data;
    } catch (error) {
        // console.error('delete_wallpaper_category ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_wallpaper_category = async (_payload) => {
    try {
        const { data } = await api.deleteAllWallpaperCategoryAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_wallpaper_category ====>>>> ', error);
        return errorResponse(error);
    };
};

// HISTORY ACTIONS
export const get_history_data = async (_currentPage, _perPage, _search, _filterDropdown) => {
    try {
        let historyData;
        if (_currentPage || _perPage || _search || _filterDropdown) {
            const { data } = await api.getHistoryAPI(_currentPage, _perPage, _search, _filterDropdown);
            historyData = data;
        } else {
            const { data } = await api.getHistoryAPI();
            historyData = data;
        }
        return historyData;
    } catch (error) {
        // console.error('get_wallpaper_categories_data ====>>>> ', error);
        return errorResponse(error);
    };
};
export const delete_all_history = async (_payload) => {
    try {
        const { data } = await api.deleteAllHistoryAPI(_payload);
        return data;
    } catch (error) {
        // console.error('delete_all_history ====>>>> ', error);
        return errorResponse(error);
    };
};

// APP_API ACTIONS
export const get_app_category_data = async () => {
    try {
        const { data } = await api.getAppCategoryAPI();
        return data;
    } catch (error) {
        // console.error('get_app_category_data ====>>>> ', error);
        return errorResponse(error);
    };
}
export const get_app_categories_data_by_category = async (_payload) => {
    try {
        const { data } = await api.getAppCategoryDataAPI(_payload);
        return data;
    } catch (error) {
        // console.error('get_app_category_data ====>>>> ', error);
        return errorResponse(error);
    };
}